// extracted by mini-css-extract-plugin
export default {"positive":"afc0nD","positiveInverted":"bfc0nD","negative":"cfc0nD","negativeInverted":"dfc0nD"};